<body>
  <div class="table-container">
    <div class="table-header">
      <!-- header texts -->
      <app-operations-header
        [header]="CONST.OPERATIONS.HEADER"
        [subHeader]="CONST.OPERATIONS.SUBHEADER"
      ></app-operations-header>

      <!-- header summary table -->
      <app-summary-dashboard
        [summaryData$]="summaryData$"
      ></app-summary-dashboard>
    </div>

    <!-- header actions -->
    <ion-row>
      <ion-col class="date-picker">
        <app-form-date-picker
          [minDate]="minDate"
          [maxDate]="maxDate"
          [(ngModel)]="date"
          [ngModelOptions]="{ standalone: true }"
          (valueChange)="dateChanged($event)"
        ></app-form-date-picker>
      </ion-col>

      <ion-col class="table-icons">
        <app-table-header
          [hasHeader]="false"
          [showHeader]="false"
          [filterDisabled]="filterDisabled"
          [hasSingleAlternateAddItem]="true"
          [alternateAddItemSrc]="IMAGES.LOCATION_WHITE"
          [alternateAddButtonText]="CONST.ADD_ROUTE"
          [rightPadding]="0"
          [hasCollapsedPadding]="false"
          (clearFilterEvent)="clearFilter()"
          (addItemEvent)="sendAddPickupSignal()"
          (exportExcelEvent)="exportExcel()"
        >
        </app-table-header>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <app-pickup
          [pickupData$]="updatedData$"
          [summaryRoutes]="summaryRoutes"
          [resetClick]="resetSelectDropdowns"
          [exportExcelEvent]="exportExcelEvent"
          [addPickupEvent]="addPickupEvent"
          (emitEnableClearFilterEvent)="enableClearFilterIcon($event)"
          (refetchData)="getAllPickups(currLocation)"
        ></app-pickup>
      </ion-col>
    </ion-row>
  </div>
</body>
